import { cn } from '@/lib/utils';

interface TierBadgeProps {
  tier: 1 | 2 | 3;
  size?: 'sm' | 'md' | 'lg';
}

const tierConfig = {
  1: {
    label: 'Optimal',
    bg: 'bg-emerald-100',
    text: 'text-emerald-700',
    border: 'border-emerald-300',
    dot: 'bg-emerald-500',
  },
  2: {
    label: 'Suboptimal',
    bg: 'bg-amber-100',
    text: 'text-amber-700',
    border: 'border-amber-300',
    dot: 'bg-amber-500',
  },
  3: {
    label: 'Clinical Attention',
    bg: 'bg-red-100',
    text: 'text-red-700',
    border: 'border-red-300',
    dot: 'bg-red-500',
  },
};

const sizeClasses = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-3 py-1 text-sm',
  lg: 'px-4 py-1.5 text-base font-medium',
};

export function TierBadge({ tier, size = 'md' }: TierBadgeProps) {
  const config = tierConfig[tier];

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border',
        config.bg,
        config.text,
        config.border,
        sizeClasses[size]
      )}
    >
      <span className={cn('h-2 w-2 rounded-full', config.dot)} />
      Tier {tier}: {config.label}
    </span>
  );
}
